.bb {
  /*margin: auto;*/
  /*background: $codepen-logo-path no-repeat 50% / 70% rgba(0,0,0, .1);*/
  /*box-shadow: inset 0 0 0 1px rgba(var(--main-color), .5);*/

  &::before,
  &::after {
    content: '';
    z-index: -1;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
  }
}
